import { Component, OnInit } from '@angular/core'
import { Router, RouterLink, RouterLinkActive } from '@angular/router'
import { MenuListModel } from '../../models/menu.model'
import { LISTROUTES } from '../routes'
import { AuthService } from '../../services/auth/auth.service'
import { NgClass } from '@angular/common'

@Component({
  selector: 'template-sidebar',
  imports: [RouterLink, RouterLinkActive, NgClass],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  providers: [AuthService],
})
export class SidebarComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  listMenu: MenuListModel[] = []
  menu: MenuListModel[] = LISTROUTES
  permissions: string[] = []
  menuSelected = ''
  permissionsList: any[] = []

  ngOnInit() {
    this.permissionsList = this.authService.getPermissionsObject()
    for (let i = 0; i < this.permissionsList.length; i++) {
      const item = this.permissionsList[i]
      if (item.nomeFuncao.toLowerCase() == 'paginado') {
        this.permissions.push(
          'view-' + item.nomeTela.toLowerCase().replaceAll(' ', '-'),
        )
      }
    }
    if (this.permissions.length > 0) {
      this.createMenu()
    }
  }

  createMenu() {
    const list: MenuListModel[] = []
    for (let indexMenu = 0; indexMenu < this.menu.length; indexMenu++) {
      const menu = this.menu[indexMenu]
      if (menu.type == 'title' && this.permissions.includes(menu.permission!)) {
        list.push(menu)
      } else if (menu.type == 'subTitle') {
        const children: any[] = []
        for (
          let indexSubItem = 0;
          indexSubItem < menu.children!.length;
          indexSubItem++
        ) {
          const child = menu.children![indexSubItem]
          if (this.permissions.includes(child.permission!)) {
            children.push(child)
          }
        }
        if (children.length > 0) {
          const newMenu: any = menu
          newMenu.children = children
          list.push(newMenu)
        }
      }
    }
    this.listMenu = list
  }

  menuToggle(menu: string) {
    this.menuSelected = this.menuSelected == menu ? '' : menu
  }

  navigateTo(route: string) {
    this.router.navigate([route])
  }
}
